import React from 'react';
import PropTypes from 'prop-types';
import CommonModalShell from '../../common/ModalShell';

// The User Management modals share the common modal shell, pinned to this feature's
// title id. `width` defaults to the shell's 480px but richer forms (Add User) can widen it.
function ModalShell({ open, onClose, title, width, children }) {
  return (
    <CommonModalShell
      open={open}
      onClose={onClose}
      title={title}
      titleId='user-management-modal-title'
      {...(width ? { width } : {})}
    >
      {children}
    </CommonModalShell>
  );
}

ModalShell.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]),
  children: PropTypes.node,
};

export default ModalShell;
